import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import Layout from "../layouts/app"
import { getTranslationUri } from "../utils/i18n"
import { PostContent } from "./post/PostContent"
import { PostHeader } from "./post/PostHeader"
import { RelatedItems } from "./post/RelatedItems"

function ArticleTemplate({ item, defaultRelatedItems, type }) {
  const {
    language: { locale },
    translations,
    postContent,
  } = item

  const relatedPosts = postContent?.relatedPosts
  const featuredImage = item?.featuredImage?.node

  const getRelatedItems = () => {
    if (type === "client") {
      return defaultRelatedItems?.nodes
    }
    if (
      relatedPosts?.relatedPost1 ||
      relatedPosts?.relatedPost2 ||
      relatedPosts?.relatedPost3
    ) {
      const selectedRelatedPosts = [
        relatedPosts?.relatedPost1 ? relatedPosts.relatedPost1 : [],
        relatedPosts?.relatedPost2 ? relatedPosts.relatedPost2 : [],
        relatedPosts?.relatedPost3 ? relatedPosts.relatedPost3 : [],
      ]
      return [
        ...selectedRelatedPosts,
        ...(defaultRelatedItems ? defaultRelatedItems.nodes : []),
      ].slice(0, 3)
    }
    return defaultRelatedItems?.nodes
  }

  return (
    <Layout
      // location={location}
      locale={locale}
      translationUri={getTranslationUri(translations, locale)}
      postType={type}
    >
      <div className="relative overflow-hidden">
        <div className="relative">
          <div className="p-4 mx-auto text-lg bg-white sm:rounded-lg max-w-prose-articles sm:p-6 lg:p-8">
            <PostHeader post={item} locale={locale} />
            {featuredImage && (
              <GatsbyImage
                className="object-cover w-full h-48 my-6 transition-all rounded md:h-96 sm:h-72"
                image={
                  featuredImage?.localFile?.childImageSharp?.gatsbyImageData
                }
                alt={featuredImage?.alt || ``}
              />
            )}
            <PostContent post={item} content={item.postContent} />
          </div>
        </div>
      </div>
      {getRelatedItems().length > 0 && (
        <RelatedItems
          relatedItems={getRelatedItems()}
          type={type}
          locale={locale}
        />
      )}
    </Layout>
  )
}

export default ArticleTemplate
